<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
				<el-form-item :label="$t('statistic_index.teacher')" prop="teacher" data-name="teacher">
					<el-select v-model="filterForm.teacher" :placeholder="$t('index.pleaseInput')">
						<el-option v-for="(item,index) in teacherList" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('statistic_index.date')" prop="date" data-name="date">
					<el-date-picker v-model="filterForm.date" type="daterange" value-format="timestamp" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="init()">{{$t('index.search')}}</el-button>
					<el-button type="" size="mini" @click="reset()">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="list" border size="mini" row-key="id" default-expand-all :tree-props="{children: 'course_list'}">
			<el-table-column :prop="lang=='cn'?'name_cn':'name'" align="" data-name="老师" :label="$t('statistic_index.teacher')">
				<template slot-scope="scope">
					<router-link :to="{path:'/virtual_index',query:{ id: scope.row.id,course_type:'course',table:'student_list' } }" v-if="scope.row.id" class="router_link">{{lang=='cn'?scope.row.name_cn:scope.row.name}}</router-link>
					<span v-else>{{lang=='cn'?scope.row.name_cn:scope.row.name}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="class_num" align="center" data-name="课次" :label="$t('statistic_index.class_num')" ></el-table-column>
			<el-table-column prop="all_need_form_num" align="center" data-name="应填写评测表" :label="$t('statistic_index.should')"></el-table-column>
			<el-table-column prop="all_over_form_num" align="center" data-name="已填写评测表" :label="$t('statistic_index.already')"></el-table-column>
		</el-table>
	</div>
</template>
<script>
export default {
	data() {
		return {
			list: [],
			filterForm: {
				teacher:'',
				date:null,
			},
			teacherList:[],
		}
	},
	// 初始事件
	mounted: function () {
		this.getSchoolWebModuleMessageListFunc();
		this.config();
		this.init();
	},
	destroyed(){
		sessionStorage.removeItem("virtual_index");
	},
	// 事件
	methods: {
		getSchoolWebModuleMessageListFunc(){
			if(sessionStorage.getItem('virtual_index')){
				this.filterForm=JSON.parse(sessionStorage.getItem('statistic_index'))||{
					teacher:'',
					date:null,
				};
			}else{
				this.filterForm={
					teacher:'',
					date:null,
				}
				sessionStorage.removeItem("virtual_index");
			}
		},
		config() {
			var this_ = this;
			var url = "teacherListNopage";
			this_.$post(url, {}).then((res) => {
				this_.teacherList = res;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "teacherFormCount";
			var datas = {
				teacher_id: this_.filterForm.teacher,
			};
			if (this_.filterForm.date&&this_.filterForm.date.length>0) {
				datas['start_time']=Math.round((this_.filterForm.date[0])/1000);
				datas['end_time']=Math.round((this_.filterForm.date[1])/1000);
			}
			this_.$post(url, datas).then((res) => {
				sessionStorage.setItem('statistic_index',JSON.stringify(this_.filterForm));
				res.forEach(function(e,i) {
					var course_list=e.course_list;
					course_list.forEach( function(n,j) {
						n['all_need_form_num']=n.form_num;
						n['all_over_form_num']=n.over_form_num;
						n['name_cn']=n.theme_cn;
						n['name']=n.theme;
					});
					e['id']='aa'+i;
				});
				this_.list = res;
			})
		},
		// 重置
		reset() {
			this.filterForm.teacher = '';
			this.filterForm.date = null;
			this.init();
		},

	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
</style>
<style>
.demo-table-expand .el-form-item__label{
	padding: 0;
}
.demo-table-expand .el-form--inline .el-form-item{
	margin-right: 20px;
}
.router_link{
	display: inline;
	color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/views/statistic/index.vue